import { PRICING_PAGE } from "@/lib/constants";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function PricingFAQ() {
  const { faq } = PRICING_PAGE;

  return (
    <section
      data-testid="pricing-faq-section"
      className="bg-[#F9FAFB] py-12 md:py-20"
      aria-label="Frequently asked questions"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-[#1A1A1A] text-center tracking-tight mb-12">
          {faq.heading}
        </h2>

        <Accordion type="single" collapsible className="w-full">
          {faq.items.map((item, i) => (
            <AccordionItem
              key={i}
              value={`pricing-faq-${i}`}
              className="border-b border-gray-200"
              data-testid={`pricing-faq-item-${i}`}
            >
              <AccordionTrigger
                className="text-left text-base font-semibold text-[#1A1A1A] py-5 hover:no-underline hover:text-[#20611B] transition-colors"
                data-testid={`pricing-faq-trigger-${i}`}
              >
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-[#6B7280] leading-relaxed pb-5">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
